import styled, { css } from 'styled-components'
// utils
import { ellipsis } from 'polished'

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  width: calc(100% - 48px);
`

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  padding: 6px 0;
`

export const NodeTitle = styled.div`
  max-width: 440px;
`

export const Path = styled.span`
  font-size: 12px;
  ${ellipsis('100%')};
`

export const ContentInnerWrapper = styled.div<{ $isNodeReferenced: boolean }>`
  height: ${({ $isNodeReferenced }) => ($isNodeReferenced ? 'unset' : '25px')};
  overflow: hidden;

  ${({ $isNodeReferenced }) =>
    $isNodeReferenced &&
    css`
      display: flex;
      flex-direction: column;

      > :first-child {
        flex: none;
        height: 20px;
      }
    `}
`
